import React, { useState, useEffect } from 'react';
import { Menu, X, ExternalLink } from 'lucide-react';
import { companyInfo, navigationLinks } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm py-4 shadow-sm' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex items-center gap-3"
          >
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto"
              style={{ backgroundColor: 'transparent' }}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 uppercase ${
                  isScrolled ? 'text-gray-600 hover:text-black' : 'text-gray-600 hover:text-black'
                }`}
              >
                {link.label}
              </a>
            ))}
            {/* AgriTrack System Link */}
            <a
              href="http://agritrack-app-78377568014.europe-west9.run.app"
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-2 text-sm font-medium tracking-wide transition-colors duration-200 uppercase px-4 py-2 border ${
                isScrolled 
                  ? 'border-black text-black hover:bg-black hover:text-white' 
                  : 'border-black text-black hover:bg-black hover:text-white'
              }`}
            >
              AgriTrack
              <ExternalLink className="w-4 h-4" />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-black hover:bg-gray-100' : 'text-black hover:bg-black/10'
            }`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className={`lg:hidden mt-6 pb-6 border-t pt-6 ${
            isScrolled ? 'border-gray-200' : 'border-gray-200'
          }`}>
            <div className="flex flex-col gap-4">
              {navigationLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(link.href);
                  }}
                  className={`text-base font-medium tracking-wide transition-colors duration-200 uppercase py-2 ${
                    isScrolled ? 'text-gray-600 hover:text-black' : 'text-gray-600 hover:text-black'
                  }`}
                >
                  {link.label}
                </a>
              ))}
              {/* AgriTrack System Link - Mobile */}
              <a
                href="http://agritrack-app-78377568014.europe-west9.run.app"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-base font-medium tracking-wide transition-colors duration-200 uppercase py-2 text-green-600 hover:text-green-700"
              >
                AgriTrack
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
